import { IoIosArrowDropup, IoMdInformationCircleOutline } from "react-icons/io"
import { data } from "react-router-dom"

// htmls
const roomMarkersData = [
	{
		id: "living-room-a-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Living Room - View 1",
		type: "room"
	},
	{
		id: "living-room-b-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Living Room - View 2",
		type: "room"
	},
	{
		id: "living-room-c-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Living Room - View 3",
		type: "room"
	},
	{
		id: "living-room-c-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Living Room - View 3",
		type: "room"
	},
	{
		id: "hallway-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Hallway",
		type: "room"
	},
	{
		id: "main-entrance-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Main Entrance",
		type: "room"
	},
	{
		id: "bathroom-entrance-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Bathroom Entrance",
		type: "room"
	},
	{
		id: "bathroom-1-a-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Bathroom 1 - View 1",
		type: "room"
	},
	{
		id: "bathroom-1-b-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Bathroom 1 - View 2",
		type: "room"
	},
	{
		id: "bathroom-2-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Bathroom 2",
		type: "room"
	},
	{
		id: "meeting-room-entrance-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Meeting Room Entrance",
		type: "room"
	},
	{
		id: "meeting-room-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom.jpg',
		icon: IoIosArrowDropup,
		name: "Meeting Room",
		type: "room"
	},
	{
		id: "bedroom-entrance-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Bedrooms Entrance",
		type: "room"
	},
	{
		id: "second-bedroom-a-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_bedroom.jpg',
		icon: IoIosArrowDropup,
		name: "Second Bedroom - View 1",
		type: "room"
	},
	{
		id: "second-bedroom-b-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_bedroom.jpg',
		icon: IoIosArrowDropup,
		name: "Second Bedroom - View 2",
		type: "room"
	},
	{
		id: "main-bedroom-living-room-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
		icon: IoIosArrowDropup,
		name: "Main Bedroom - Living Room",
		type: "room"
	},
	{
		id: "main-bedroom-a-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_view.jpg',
		icon: IoIosArrowDropup,
		name: "Main Bedroom - View 1",
		type: "room"
	},
	{
		id: "main-bedroom-b-marker",
		img: 'assets/HotelMerlynn_Thumbnails/mph_residence_view.jpg',
		icon: IoIosArrowDropup,
		name: "Main Bedroom - View 2",
		type: "room"
	},
]

// htmls
const infoMarkersData = [
	{
		id: "painting-info",
		icon: IoMdInformationCircleOutline,
		name: "Painting",
		type: "info"
	},
	{
		id: "book-info",
		icon: IoMdInformationCircleOutline,
		name: "Book",
		type: "info"
	},
	{
		id: "modern-kitchen-info",
		icon: IoMdInformationCircleOutline,
		name: "Modern Kitchen",
		type: "info"
	},
	{
		id: "premium-living-room-info",
		icon: IoMdInformationCircleOutline,
		name: "Premium Living Room",
		type: "info"
	},
	{
		id: "dining-area-info",
		icon: IoMdInformationCircleOutline,
		name: "Dining Area",
		type: "info"
	},
	{
		id: "panoramic-view-info",
		icon: IoMdInformationCircleOutline,
		name: "Panoramic View",
		type: "info"
	},
	{
		id: "luxury-bathroom-1-a-info",
		icon: IoMdInformationCircleOutline,
		name: "Luxury Bathroom",
		type: "info"
	},
	{
		id: "luxury-bathroom-1-b-info",
		icon: IoMdInformationCircleOutline,
		name: "Luxury Bathroom",
		type: "info"
	},
	{
		id: "luxury-bathroom-2-info",
		icon: IoMdInformationCircleOutline,
		name: "Luxury Bathroom",
		type: "info"
	},
	{
		id: "multipurpose-room-info",
		icon: IoMdInformationCircleOutline,
		name: "Multipurpose Room/Study",
		type: "info"
	},
	{
		id: "premium-second-bedroom-a-info",
		icon: IoMdInformationCircleOutline,
		name: "Premium Second Bedroom",
		type: "info"
	},
	{
		id: "premium-second-bedroom-b-info",
		icon: IoMdInformationCircleOutline,
		name: "Premium Second Bedroom",
		type: "info"
	},
	{
		id: "premium-main-bedroom-a-info",
		icon: IoMdInformationCircleOutline,
		name: "Premium Main Bedroom",
		type: "info"
	},
	{
		id: "premium-main-bedroom-b-info",
		icon: IoMdInformationCircleOutline,
		name: "Premium Main Bedroom",
		type: "info"
	},
]

const panelContentsData = [
	{
		id: "book-info-content",
		//depends on roomMarkerMapData markers
		marker: "book-info-marker",
		file: "/assets/Virtual Exhibition.pdf#zoom=41",
		url: null,
		img: null,
		longText: null,
	},
	{
		id: "painting-info-content",
		marker: "painting-info-marker",
		url: "https://en.wikipedia.org/wiki/Sunflowers_(Van_Gogh_series)",
	},
	{
		id: "modern-kitchen-info-content",
		marker: "modern-kitchen-info-marker",
		longText: "<p><strong>Modern Kitchen:</strong></p> <ul> <li>Curved kitchen island with integrated seating</li> <li>Modern cooktop and hood</li> <li>Premium cabinets with black finishing</li> <li>Black granite/marble countertop</li> </ul>",
	},
	{
		id: "premium-living-room-info-content",
		marker: "premium-living-room-info-marker",
		longText: "<p><strong>Premium Living Room:</strong></p> <ul> <li>Luxury sofa set with coffee table</li> <li>Direct access to balcony with city views</li> <li>Floor-to-ceiling windows for maximum natural lighting</li> <li>Premium curtains</li> </ul>",
	},
	{
		id: "dining-area-info-content",
		marker: "dining-area-info-marker",
		longText: "<p><strong>Dining Area:</strong></p> <ul> <li>Dining table for 6-8 people</li> <li>Premium dining chair set</li> <li>Spacious entertaining area</li> </ul>",
	},
	{
		id: "panoramic-view-info-content",
		// marker yg dicari sama roomMarkerMapData.markers.id
		marker: "panoramic-view-info-marker",
		longText: "<p><strong>Panoramic View:</strong></p> <ul> <li>Curved floor-to-ceiling windows 180&deg;</li> <li>Spectacular Jakarta city views</li> <li>Private balcony with glass railing</li> <li>Natural lighting throughout the day</li> </ul>",
	},
	{
		id: "luxury-bathroom-1-b-info-content",
		marker: "luxury-bathroom-1b-info-marker",
		longText: "<p><strong>Luxury Bathroom:</strong></p> <ul> <li>Premium bathtub with shower access</li> <li>Large mirror with elegant frame</li> </ul>",
	},
	{
		id: "luxury-bathroom-1-a-info-content",
		marker: "luxury-bathroom-1-a-info-marker",
		longText: "<p><strong>Luxury Bathroom:</strong></p> <ul> <li>Washbasin with modern countertop</li> <li>Toilet with minimalist design</li> </ul>",
	},
	{
		id: "luxury-bathroom-2-info-content",
		marker: "luxury-bathroom-2-info-marker",
		longText: "<p><strong>Luxury Bathroom:</strong></p> <ul> <li>Premium bathtub with shower access</li> <li>Large mirror with elegant frame</li> <li>Washbasin with modern countertop</li> <li>Toilet with minimalist design</li> <li>Men's bidet area</li> </ul>",
	},
	{
		id: "multipurpose-room-info-content",
		marker: "multipurpose-room-info-marker",
		longText: "<p><strong>Multi-Purpose Room/Study:</strong></p> <ul> <li>Office desk/workspace with ergonomic chair</li> <li>Built-in wall unit for storage and display</li> <li>Large window with city view</li> <li>Area that can be used as home office or study room</li> </ul>",
	},
	{
		id: "premium-second-bedroom-a-info-content",
		marker: "premium-second-bedroom-a-info-marker",
		longText: "<p><strong>Premium 2nd Bedroom:</strong></p> <ul> <li>Built-in wardrobe with mirror doors</li> <li>TV area with entertainment system</li> <li>Desk with chair for work or as vanity table</li> </ul>",
	},
	{
		id: "premium-second-bedroom-b-info-content",
		marker: "premium-second-bedroom-b-info-marker",
		longText: "<p><strong>Premium 2nd Bedroom:</strong></p> <ul> <li>King size bed with luxury headboard</li> <li>Small living room area in bedroom with sofa set and table</li> </ul>",
	},
	{
		id: "premium-main-bedroom-a-info-content",
		marker: "premium-main-bedroom-a-info-marker",
		longText: "<p><strong>Premium Main Bedroom:</strong></p> <ul> <li>King size bed with luxury headboard</li> <li>Built-in seating area with ottoman</li> <li>Vanity table right next to master bed</li> </ul>",
	},
	{
		id: "premium-main-bedroom-b-info-content",
		marker: "premium-main-bedroom-b-info-marker",
		longText: "<p><strong>Premium Main Bedroom:</strong></p> <ul> <li>Built-in wardrobe with mirror doors</li> <li>TV area with entertainment system</li> </ul>",
	},
]

const autorotatePointData = [
	{	yaw: "170deg", pitch: "0deg" },  // hallway-marker
	{ yaw: "45deg", pitch: "0deg" },  // living-room-b-marker
	{	yaw: "340deg", pitch: "0deg" },  // living-room-a-marker
	{	yaw: "320deg", pitch: "0deg" },  // living-room-c-marker
	{ yaw: "250deg", pitch: "0deg" },  // main-entrance-marker
	{ yaw: "0deg", pitch: "0deg" },  // bathroom-entrance-marker
	{ yaw: "340deg", pitch: "0deg" },  // bathroom-1-a-marker
	{ yaw: "15deg", pitch: "0deg" },  // bathroom-1-b-marker
	{ yaw: "215deg", pitch: "0deg" },  // bathroom-2-marker
	{ yaw: "0deg", pitch: "0deg" },  // meeting-room-entrance-marker
	{ yaw: "335deg", pitch: "0deg" },  // meeting-room-marker
	{ yaw: "25deg", pitch: "0deg" },  // bedroom-entrance-marker
	{ yaw: "7deg", pitch: "0deg" },  // second-bedroom-a-marker
	{ yaw: "160deg", pitch: "0deg" },  //second-bedroom-b-marker
	{ yaw: "90deg", pitch: "0deg" },  // main-bedroom-living-room-marker
	{ yaw: "80deg", pitch: "0deg" },  // main-bedroom-a-marker
	{ yaw: "40deg", pitch: "0deg" },  // main-bedroom-b-marker
]

const roomMarkerMapData = [
	{
		id: "hallway-marker",
		panorama: "assets/HotelMerlynn_360_4k/A4_Tripodless.jpg",
		markers: [
			{
				id: "bathroom-entrance-marker",
				html: "bathroom-entrance-marker",
				position: { yaw: "340deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "main-entrance-marker",
				html: "main-entrance-marker",
				position: { yaw: "260deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "living-room-b-marker",
				html: "living-room-b-marker",
				position: { yaw: "170deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bedroom-entrance-marker",
				html: "bedroom-entrance-marker",
				position: { yaw: "0deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "living-room-b-marker",
		panorama: "assets/HotelMerlynn_360_4k/A2_Tripodless.jpg",
		markers: [
			{
				id: "hallway-marker",
				html: "hallway-marker",
				position: { yaw: "215deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "living-room-c-marker",
				html: "living-room-c-marker",
				position: { yaw: "335deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "living-room-a-marker",
				html: "living-room-a-marker",
				position: { yaw: "45deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "dining-area-info-marker",
				html: "dining-area-info",
				position: { yaw: "75deg", pitch: "-15deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
			{
				id: "premium-living-room-info-marker",
				html: "premium-living-room-info",
				position: { yaw: "355deg", pitch: "-20deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "living-room-a-marker",
		panorama: "assets/HotelMerlynn_360_4k/A1_Tripodless.jpg",
		markers: [
			{
				id: "living-room-c-marker",
				html: "living-room-c-marker",
				position: { yaw: "200deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "living-room-b-marker",
				html: "living-room-b-marker",
				position: { yaw: "160deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				// id marker dg type info akan digunakan untuk cari di panelContentsData.marker
				id: "modern-kitchen-info-marker",
				// html akan ambil dr infoMarkersData berdasarkan id nya
				html: "modern-kitchen-info",
				position: { yaw: "340deg", pitch: "-20deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "living-room-c-marker",
		panorama: "assets/HotelMerlynn_360_4k/A3_Tripodless.jpg",
		markers: [
			{
				id: "living-room-a-marker",
				html: "living-room-a-marker",
				position: { yaw: "250deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "living-room-b-marker",
				html: "living-room-b-marker",
				position: { yaw: "320deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "panoramic-view-info-marker",
				html: "panoramic-view-info",
				position: { yaw: "90deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "main-entrance-marker",
		panorama: "assets/HotelMerlynn_360_4k/A6_Tripodless.jpg",
		markers: [
			{
				id: "hallway-marker",
				html: "hallway-marker",
				position: { yaw: "250deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "bathroom-entrance-marker",
		panorama: "assets/HotelMerlynn_360_4k/A7_Tripodless.jpg",
		markers: [
			{
				id: "hallway-marker",
				html: "hallway-marker",
				position: { yaw: "110deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "meeting-room-entrance-marker",
				html: "meeting-room-entrance-marker",
				position: { yaw: "265deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bathroom-1-a-marker",
				html: "bathroom-1-a-marker",
				position: { yaw: "170deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bathroom-2-marker",
				html: "bathroom-2-marker",
				position: { yaw: "210deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bedroom-entrance-marker",
				html: "bedroom-entrance-marker",
				position: { yaw: "0deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "bathroom-1-a-marker",
		panorama: "assets/HotelMerlynn_360_4k/A8_Tripodless.jpg",
		markers: [
			{
				id: "bathroom-entrance-marker",
				html: "bathroom-entrance-marker",
				position: { yaw: "340deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bathroom-1-b-marker",
				html: "bathroom-1-b-marker",
				position: { yaw: "285deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "luxury-bathroom-1-a-info-marker",
				html: "luxury-bathroom-1-a-info",
				position: { yaw: "60deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "bathroom-1-b-marker",
		panorama: "assets/HotelMerlynn_360_4k/A8_B_Tripodless.jpg",
		markers: [
			{
				id: "bathroom-1-a-marker",
				html: "bathroom-1-a-marker",
				position: { yaw: "250deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "luxury-bathroom-1-b-info-marker",
				html: "luxury-bathroom-1-b-info",
				position: { yaw: "15deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "bathroom-2-marker",
		panorama: "assets/HotelMerlynn_360_4k/A9_Tripodless.jpg",
		markers: [
			{
				id: "bathroom-entrance-marker",
				html: "bathroom-entrance-marker",
				position: { yaw: "215deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "luxury-bathroom-2-info-marker",
				html: "luxury-bathroom-2-info",
				position: { yaw: "0deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "meeting-room-entrance-marker",
		panorama: "assets/HotelMerlynn_360_4k/A10_Tripodless.jpg",
		markers: [
			{
				id: "meeting-room-marker",
				html: "meeting-room-marker",
				position: { yaw: "0deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bathroom-entrance-marker",
				html: "bathroom-entrance-marker",
				position: { yaw: "257deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "meeting-room-marker",
		panorama: "assets/HotelMerlynn_360_4k/A11_Tripodless.jpg",
		markers: [
			{
				id: "meeting-room-entrance-marker",
				html: "meeting-room-entrance-marker",
				position: { yaw: "335deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "multipurpose-room-info-marker",
				html: "multipurpose-room-info",
				position: { yaw: "333deg", pitch: "-12deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "bedroom-entrance-marker",
		panorama: "assets/HotelMerlynn_360_4k/A12_Tripodless.jpg",
		markers: [
			{
				id: "bathroom-entrance-marker",
				html: "bathroom-entrance-marker",
				position: { yaw: "115deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "second-bedroom-a-marker",
				html: "second-bedroom-a-marker",
				position: { yaw: "25deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "main-bedroom-living-room-marker",
				html: "main-bedroom-living-room-marker",
				position: { yaw: "295deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "second-bedroom-a-marker",
		panorama: "assets/HotelMerlynn_360_4k/A13_Tripodless.jpg",
		markers: [
			{
				id: "bedroom-entrance-marker",
				html: "bedroom-entrance-marker",
				position: { yaw: "145deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "premium-second-bedroom-a-info-marker",
				html: "premium-second-bedroom-a-info",
				position: { yaw: "7deg", pitch: "-20deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
			{
				id: "second-bedroom-b-marker",
				html: "second-bedroom-b-marker",
				position: { yaw: "275deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "second-bedroom-b-marker",
		panorama: "assets/HotelMerlynn_360_4k/A13_B_Tripodless.jpg",
		markers: [
			{
				id: "second-bedroom-a-marker",
				html: "second-bedroom-a-marker",
				position: { yaw: "160deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "premium-second-bedroom-b-info-marker",
				html: "premium-second-bedroom-b-info",
				position: { yaw: "230deg", pitch: "-10deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "main-bedroom-living-room-marker",
		panorama: "assets/HotelMerlynn_360_4k/A14_Tripodless.jpg",
		markers: [
			{
				id: "main-bedroom-a-marker",
				html: "main-bedroom-a-marker",
				position: { yaw: "90deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bedroom-entrance-marker",
				html: "bedroom-entrance-marker",
				position: { yaw: "65deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "main-bedroom-a-marker",
		panorama: "assets/HotelMerlynn_360_4k/A14_B_Tripodless.jpg",
		markers: [
			{
				id: "main-bedroom-b-marker",
				html: "main-bedroom-b-marker",
				position: { yaw: "110deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "main-bedroom-living-room-marker",
				html: "main-bedroom-living-room-marker",
				position: { yaw: "300deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "premium-main-bedroom-a-info-marker",
				html: "premium-main-bedroom-a-info",
				position: { yaw: "80deg", pitch: "-20deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
	{
		id: "main-bedroom-b-marker",
		panorama: "assets/HotelMerlynn_360_4k/A14_C_Tripodless.jpg",
		markers: [
			{
				id: "main-bedroom-a-marker",
				html: "main-bedroom-a-marker",
				position: { yaw: "40deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "premium-main-bedroom-b-info-marker",
				html: "premium-main-bedroom-b-info",
				position: { yaw: "20deg", pitch: "-7deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
		]
	},
]

const galleryData = [
  {
    id: 'main-bedroom-living-room',
    panorama: 'assets/HotelMerlynn_360_4k/A14_Tripodless.jpg',
    thumbnail: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    name: 'Main Bedroom - Living Room',
    options: {
        caption: 'Main Bedroom - Living Room',
    },
  },	
  {
    id: 'main-bedroom-a',
    panorama: 'assets/HotelMerlynn_360_4k/A14_B_Tripodless.jpg',
    thumbnail: 'assets/HotelMerlynn_Thumbnails/mph_residence_view.jpg',
    name: 'Main Bedroom - View 1',
    options: {
        caption: 'Main Bedroom - View 1',
    },
  },	
  {
    id: 'second-bedroom-a',
    panorama: 'assets/HotelMerlynn_360_4k/A13_Tripodless.jpg',
    thumbnail: 'assets/HotelMerlynn_Thumbnails/mph_residence_bedroom.jpg',
    name: 'Second Bedroom - View 1',
    options: {
        caption: 'Second Bedroom - View 1',
    },
  },	
  {
    id: 'meeting-room',
    panorama: 'assets/HotelMerlynn_360_4k/A11_Tripodless.jpg',
    thumbnail: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom.jpg',
    name: 'Meeting Room',
    options: {
        caption: 'Meeting Room',
    },
  },	
]

const mapData = [
	{
		imageUrl: 'assets/HotelMerlynn_Map/The Residence Map.png',
		center: { x: 595, y: 520 },
		rotation: '30',
		static: 'true',
		coneColor: '#3498db',
		buttons: {
			reset: false,    // hides the reset zoom button
		},
		// coneSize: '80',
		coneSize: '0',
		defaultZoom: '50',
		minZoom: '50',
		maxZoom: '50',
		hotspots: [
			{
				// I
				id: 'living-room-a',
				x: 1200,
				y: 680,
				color: '#ffcc00',
				tooltip: 'Living Room - View 1',
			},
			{
				// II
				id: 'living-room-b',
				x: 750,
				y: 520,
				color: '#ffcc00',
				tooltip: 'Living Room - View 2',
			},
			{
				// III
				id: 'living-room-c',
				x: 1000,
				y: 325,
				color: '#ffcc00',
				tooltip: 'Living Room - View 3',
			},
			{
				// IV
				id: 'hallway',
				x: 595,
				y: 520,
				color: '#ffcc00',
				tooltip: 'Hallway',
			},
			{
				// VI
				id: 'main-entrance',
				x: 595,
				y: 700,
				color: '#ffcc00',
				tooltip: 'Main Entrance',
			},
			{
				// VII
				id: 'bathroom-entrance',
				x: 400,
				y: 565,
				color: '#ffcc00',
				tooltip: 'Bathroom Entrance',
			},
			{
				// VIII 
				id: 'bathroom-1-a',
				x: 495,
				y: 615,
				color: '#ffcc00',
				tooltip: 'Bathroom 1 - View 1',
			},
			{
				// VIII B
				id: 'bathroom-1-b',
				x: 465,
				y: 800,
				color: '#ffcc00',
				tooltip: 'Bathroom 1 - View 2',
			},
			{
				// IX
				id: 'bathroom-2',
				x: 330,
				y: 800,
				color: '#ffcc00',
				tooltip: 'Bathroom 2',
			},
			{
				// X
				id: 'meeting-room-entrance',
				x: 240,
				y: 565,
				color: '#ffcc00',
				tooltip: 'Meeting Room Entrance',
			},
			{
				// XI
				id: 'meeting-room',
				x: 125,
				y: 950,
				color: '#ffcc00',
				tooltip: 'Meeting Room',
			},
			{
				// XII
				id: 'bedroom-entrance',
				x: 385,
				y: 350,
				color: '#ffcc00',
				tooltip: 'Bedroom Entrance',
			},
			{
				// XIII
				id: 'second-bedroom-a',
				x: 535,
				y: 360,
				color: '#ffcc00',
				tooltip: 'Second Bedroom - View 1',
			},
			{
				// XIII B
				id: 'second-bedroom-b',
				x: 535,
				y: 70,
				color: '#ffcc00',
				tooltip: 'Second Bedroom - View 2',
			},
			{
				// XIV
				id: 'main-bedroom-living-room',
				x: 385,
				y: 70,
				color: '#ffcc00',
				tooltip: 'Main Bedroom - Living Room',
			},
			{
				// XIV B
				id: 'main-bedroom-a',
				x: 200,
				y: 250,
				color: '#ffcc00',
				tooltip: 'Main Bedroom - View 1',
			},
			{
				// XIV C
				id: 'main-bedroom-b',
				x: 85,
				y: 450,
				color: '#ffcc00',
				tooltip: 'Main Bedroom - View 2',
			},
		],
	}
]


export default {
	infoMarkersData,
	roomMarkersData,
	panelContentsData,
	roomMarkerMapData,
	galleryData,
	mapData,
	autorotatePointData
}

/***
 * would probably merge info marker with room marker as custom marker
 * their difference were just animation and the info marker don't have image
 * 
 * we use html to make custom marker but it has to be a string. so we use React
 * renderToStaticMarkup function to render React component to HTML string. 
 * But creating the marker dynamically probably needs a.. helper?
 * mainly to do the renderToString function for every marker and then pair the marker
 * to associated room. This pairing is practically a database structure haha  
 * 
 * anyway..
 * 
 * don't forget a break in switch case function
 * don't forget arrow function with {} must explicitly use return keyword as {} means a function body
 * 
 */